(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.classList.contains("tsg-header--transparent") ? this.offsetHeight : this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tsg-hero"] && !Shopify.designMode) return;
  try {
    
(() => {
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  const seen = new WeakSet();
  const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      observer.unobserve(entry.target);
      if (!reduced.matches && !window.Shopify?.designMode) {
        entry.target.animate([{opacity:0,transform:'translateY(25px)'},{opacity:1,transform:'translateY(0)'}],{duration:750,easing:'cubic-bezier(.16,1,.3,1)'});
      }
    });
  },{threshold:0.12}) : null;
  function setup(root) {
    root.querySelectorAll('[data-tsg-reveal]').forEach(el => {
      if (seen.has(el)) return;
      seen.add(el);
      if (observer && !reduced.matches) observer.observe(el);
    });
    root.querySelectorAll('[data-tsg-video-toggle]').forEach(button => {
      if (seen.has(button)) return;
      const video=button.closest('[data-tsg-hero]')?.querySelector('video');
      if (!video) return;
      seen.add(button);
      const label=()=>button.textContent=video.paused?button.dataset.playLabel:button.dataset.pauseLabel;
      video.muted = true;
      video.defaultMuted = true;
      video.playsInline = true;
      video.controls = false;
      const mobile = window.matchMedia('(max-width: 749px)');
      const playBackground = () => {
        if (reduced.matches || document.hidden) return;
        video.play().then(() => { if (!video.paused) video.classList.add('is-playing'); }).catch(() => { video.classList.remove('is-playing'); label(); });
      };
      video.addEventListener('playing', () => video.classList.add('is-playing'));
      video.addEventListener('pause', () => video.classList.remove('is-playing'));
      video.addEventListener('error', () => video.classList.remove('is-playing'));
      video.addEventListener('loadeddata', playBackground, {once:true});
      window.addEventListener('pageshow', () => { if (mobile.matches) playBackground(); });
      document.addEventListener('visibilitychange', () => { if (mobile.matches) playBackground(); });
      // One genuine interaction can resume playback when the browser requires it.
      document.addEventListener('touchend', () => { if (mobile.matches && video.paused) playBackground(); }, {once:true, passive:true});
      if(reduced.matches) video.pause();
      else playBackground();
      video.addEventListener('pause',label);
      video.addEventListener('play',label);
      button.addEventListener('click',()=>{if(video.paused)video.play().catch(label);else video.pause();});
      label();
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>setup(document));else setup(document);
  document.addEventListener('shopify:section:load',event=>setup(event.target));
  reduced.addEventListener('change',()=>{if(reduced.matches){document.querySelectorAll('[data-tsg-hero] video').forEach(video=>video.pause());document.getAnimations().filter(a=>a.effect?.target?.matches?.('[data-tsg-reveal]')).forEach(a=>a.finish());}});
})();

  } catch(e) { console.error(e); }
})();
})();
